import { useTranslation } from 'react-i18next'

interface ModeSelectionProps {
  onSelectMode: (mode: 'ai-guided' | 'form-based') => void
}

/**
 * Mode selection component - AI-guided vs form-based (FR-001)
 */
export function ModeSelection({ onSelectMode }: ModeSelectionProps) {
  const { t } = useTranslation()

  const containerStyles = {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem 1rem',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }

  const titleStyles = {
    fontSize: 'clamp(24px, 4vw, 32px)',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '2rem',
    textAlign: 'center' as const,
  }

  const optionContainerStyles = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '1rem',
  }

  const optionCardStyles = {
    padding: '1.5rem',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  }

  const optionTitleStyles = {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '0.5rem',
  }

  const optionDescriptionStyles = {
    fontSize: '14px',
    color: '#666',
    lineHeight: 1.5,
  }

  return (
    <div style={containerStyles}>
      <h2 style={titleStyles}>{t('onboarding.modeSelection.title')}</h2>

      <div style={optionContainerStyles}>
        {/* AI-Guided Option */}
        <div
          style={optionCardStyles}
          onClick={() => onSelectMode('ai-guided')}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = '#2563eb'
            e.currentTarget.style.backgroundColor = '#eff6ff'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = '#e0e0e0'
            e.currentTarget.style.backgroundColor = '#fff'
          }}
        >
          <div style={optionTitleStyles}>{t('onboarding.modeSelection.aiGuided')}</div>
          <div style={optionDescriptionStyles}>
            {t('onboarding.modeSelection.aiGuidedDescription')}
          </div>
        </div>

        {/* Form-Based Option */}
        <div
          style={optionCardStyles}
          onClick={() => onSelectMode('form-based')}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = '#2563eb'
            e.currentTarget.style.backgroundColor = '#eff6ff'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = '#e0e0e0'
            e.currentTarget.style.backgroundColor = '#fff'
          }}
        >
          <div style={optionTitleStyles}>{t('onboarding.modeSelection.formBased')}</div>
          <div style={optionDescriptionStyles}>
            {t('onboarding.modeSelection.formBasedDescription')}
          </div>
        </div>
      </div>
    </div>
  )
}
